import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { UserScope } from 'src/app/core/enums/user/user-scope.enum';
import { UserSummaryDto } from 'src/app/infrastructure/lobby-proxy/DTOs/user.dto';
import { UserProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-user/user-proxy.service';
import { AutocompleteStrategyBase, SearchSuggestion } from 'src/app/shared/ui-kit/inputs/autocomplete/search-strategy-base';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteUserSuggestionService extends AutocompleteStrategyBase {

  constructor(private readonly userProxyService: UserProxyService) {
    super()
  }

  override loadSuggestions$(text: string, maxSuggestions: number | undefined): Observable<SearchSuggestion[]> {

    return this.userProxyService.searchUsers$(
      0, maxSuggestions, UserScope.Hierarchy,
      undefined, text, undefined, undefined, undefined, undefined,
      false, 'Head', 'Nome'
    ).pipe(
      throwIfLobbyErrorCode,
      map((dto => dto.data as UserSummaryDto[])),
      map(users => users.map(user => {
        return { id: user.userId.toString(), value: user.displayName } as SearchSuggestion
      }))
    )
  }
}
